// src/styles/mixins.js
import { css } from 'styled-components';

export const boxShadow = css`
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;

export const borderRadius = css`
  border-radius: ${({ theme }) => theme.borderRadius};
`;
